import { createAsyncAction } from 'typesafe-actions';
import { HttpStatus } from 'client/ErrorHandler';
import { DownloadTypes, DownloadRequestPayload } from './types';

const downloadActions = createAsyncAction(
  DownloadTypes.DownloadRequest,
  DownloadTypes.DownloadSuccess,
  DownloadTypes.DownloadFailure
)<DownloadRequestPayload, undefined, HttpStatus>();

export default downloadActions;
